import { render, staticRenderFns } from "./optionOrder.vue?vue&type=template&id=35701283&scoped=true"
import script from "./optionOrder.vue?vue&type=script&lang=js"
export * from "./optionOrder.vue?vue&type=script&lang=js"
import style0 from "./optionOrder.vue?vue&type=style&index=0&id=35701283&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35701283",
  null
  
)

export default component.exports